import React from 'react';

export default function Loader({
  greenLoader = false,
}: {
  greenLoader?: boolean;
}) {
  return (
    <div
      className={`RXC_LOADER tw-flex-shrink-0 tw-h-6 tw-w-6 tw-animate-spin ${
        greenLoader ? 'tw-bg-loader-green' : 'tw-bg-loader'
      } tw-bg-contain`}
    ></div>
  );
}
